import { ActionTree } from "vuex";
import { RootState } from "../types";
import { MapState } from "./types";

export const actions: ActionTree<MapState, RootState> = {
};
